import React, { FC, ReactElement } from 'react';
import { ACTION_CONDITIONS_ROOT } from 'src/domains/casino/utils/test-variables';
import { Select } from 'src/domains/common/components/select/select';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { SportsbookSections } from 'src/domains/casino/webview/bonus-engine/campaign/action-conditions/sportsbook-sections/SportsbookSections';
import { CasinoSections } from 'src/domains/casino/webview/bonus-engine/campaign/action-conditions/casino-sections/CasinoSections';

interface ActionConditionsType {
    campaignId?: string;
}

export const ActionConditions: FC<ActionConditionsType> = observer('ActionConditions', (props): ReactElement => {
    const common = useCommon();
    const { actionConditionsState, editionDisabled } = CampaignCreatorState.get(common, props.campaignId);
    return (
        <div
            className='grid grid-cols-2 gap-2'
            data-test={ACTION_CONDITIONS_ROOT}
        >
            <div className='flex flex-col gap-8'>
                <section
                    data-test='betting-platform'
                    className='flex flex-col gap-6'
                >
                    <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>Betting Platform</h2>
                    <Select
                        dataTest='betting-platform-dropdown'
                        label='Betting Platform'
                        placeholder='Select'
                        values={[
                            {
                                dataTest: 'sportsbook',
                                value: 'sports-book',
                                label: 'Sportsbook',
                                onClick: (): void => {
                                    // TODO: clear casino conditions when sportsbook selected (after openapi added)
                                },
                            },
                            {
                                dataTest: 'casino',
                                value: 'casino',
                                label: 'Casino',
                                onClick: (): void => {
                                    // TODO: clear sportsbook conditions when casino selected (after openapi added)
                                },
                            },
                        ]}
                        formInputState={actionConditionsState.bettingPlatformForm}
                        errors={actionConditionsState.bettingPlatformForm.errorsForView}
                        disabled={editionDisabled}
                    />
                </section>
                {actionConditionsState.bettingPlatformForm.value === 'sports-book' && (
                    <SportsbookSections campaignId={props.campaignId} />
                )}
                {actionConditionsState.bettingPlatformForm.value === 'casino' && (
                    <CasinoSections campaignId={props.campaignId} />
                )}
            </div>
        </div>
    );
});
